import { Injectable } from '@angular/core';
import type { TaskStatusFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-find.dto';
import type { TaskFindInterface } from '@zaoblako/shared/modules/task/dtos/task-find.dto';
import { TaskStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/task.status.type.enum';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { TaskStatusService } from '@zaoblako/web/core/services/task/task-status.service';
import { DeepPartial } from '@zaoblako/web/core/types/deep-partial';
import { Observable, of, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TaskStatusStateService {
  public statuses$: Observable<TaskStatusFindInterface[]>;

  public constructor(
    private readonly taskStatusService: TaskStatusService,
    private readonly authService: AuthService,
    private readonly globalService: GlobalService
  ) {
    this.statuses$ = this.taskStatusService.find<TaskStatusFindInterface>().pipe(shareReplay(1));
  }

  public getTasksPossibleStatuses(tasks: Array<DeepPartial<TaskFindInterface>>): Observable<TaskStatusFindInterface[]> {
    if (!tasks.length) {
      return of([]);
    }

    return this.statuses$.pipe(
      map((statuses) => {
        return statuses.filter((status) => {
          if (
            [
              TaskStatusTypeEnum.DRAFT,
              TaskStatusTypeEnum.SCHEDULED,
              TaskStatusTypeEnum.ON_APPROVAL,
              TaskStatusTypeEnum.AGREED
            ].includes(status.type)
          ) {
            return tasks.every((selectedTask) => {
              if (status.type === TaskStatusTypeEnum.DRAFT) {
                return (
                  [TaskStatusTypeEnum.SCHEDULED].includes(selectedTask.status.type) &&
                  (selectedTask.createdBy?.id === this.authService.currentUser.id ||
                    selectedTask.responsible?.id === this.authService.currentUser.id ||
                    this.globalService.globalInfo.accessControlRules?.find(
                      (access) => access.systemName === 'FINANCE:BRS:APPROVE_INSTEAD_OF_OTHERS'
                    )?.isAllowed)
                );
              } else if (status.type === TaskStatusTypeEnum.SCHEDULED) {
                return (
                  [TaskStatusTypeEnum.DRAFT].includes(selectedTask.status.type) &&
                  (selectedTask.createdBy?.id === this.authService.currentUser.id ||
                    selectedTask.responsible?.id === this.authService.currentUser.id ||
                    this.globalService.globalInfo.accessControlRules?.find(
                      (access) => access.systemName === 'FINANCE:BRS:APPROVE_INSTEAD_OF_OTHERS'
                    )?.isAllowed)
                );
              } else if (status.type === TaskStatusTypeEnum.ON_APPROVAL) {
                return (
                  [TaskStatusTypeEnum.DRAFT, TaskStatusTypeEnum.SCHEDULED].includes(selectedTask.status.type) &&
                  (selectedTask.createdBy?.id === this.authService.currentUser.id ||
                    selectedTask.responsible?.id === this.authService.currentUser.id ||
                    this.globalService.globalInfo.accessControlRules?.find(
                      (access) => access.systemName === 'FINANCE:BRS:APPROVE_INSTEAD_OF_OTHERS'
                    )?.isAllowed)
                );
              } else if (status.type === TaskStatusTypeEnum.AGREED) {
                return [TaskStatusTypeEnum.ON_APPROVAL].includes(selectedTask.status.type) && selectedTask.canApprove;
              }
            });
          }
          return false;
        });
      })
    );
  }
}
